<template>
  <div class="menu-bar" :class="[isLoading ? 'disable-items' : '']">
    <div class="logo-and-menu">
      <a href="https://theos.fi/" target="_blank">
        <img
          src="@/Common/Icons/THEOS_LOGO_METAL.svg"
          alt="Logo"
          class="theos-logo"
        />
        <img class="beta-badge" src="@/Common/Icons/Beta_badge.png" />
      </a>
      <div class="list">
        <ul>
          <li>
            <router-link
              :disabled="isBeginConnectionModalOpen"
              tag="button"
              class="nav-swap"
              to="/cardano"
            >
              Mint
            </router-link>
          </li>
          <li>
            <a
              class="nav-swap"
              href="https://liquidity-mining.theos.fi/"
              target="_blank"
            >
              Liquidity Mining
            </a>
          </li>
          <li>
            <a
              class="nav-swap"
              href="https://theos.fi/faq.html"
              target="_blank"
            >
              FAQs
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="button-container">
      <app-button
        v-if="!addressCardano"
        buttonClass="app-modal-button-inverse"
        style="width: 157px"
        text="Connect to a Wallet"
        @click="loginOrSignUpCardano()"
      />
      <user-balance-and-address-cardano v-else />
    </div>
  </div>
  <div class="walletMark" :class="[wallet ? 'cardano' : '']">
    {{ wallet }}
  </div>
</template>

<script>
import { useStore } from "vuex";
import { computed } from "vue";
// import { ethereumService } from "@/main";
import { cardanoService } from "@/main";
import useAuth from "@/composables/useAuth";
import AppButton from "@/elements/AppButton.vue";
// import UserBalanceAndAddress from "../components/UserBalanceAndAddress.vue";
import UserBalanceAndAddressCardano from "../components/UserBalanceAndAddressCardano.vue";
import useMinting from "../composables/useMinting";
import { eventBus } from "../main";

export default {
  data() {
    return {
      wallet: null,
    };
  },
  components: {
    AppButton,
    // UserBalanceAndAddress,
    UserBalanceAndAddressCardano,
  },
  mounted() {
    eventBus.on("custom-event", () => {
      console.log("Custom event triggered!");
      this.wallet = "Cardano";
    });
  },
  setup() {
    const store = useStore();
    const { loginOrSignUp, loginOrSignUpCardano, openRegistrationModal } =
      useAuth(store, null, cardanoService);
    const addressCardano = computed(
      () => store.getters["contracts/getAddressCardano"]
    );
    console.log("addressCardano.value", addressCardano.value);
    const isLoading = computed(() => store.getters["minting/getIsLoading"]);

    const { isBeginConnectionModalOpen } = useMinting(store);

    // const switchToPolygonNetwork = () => {
    //   return ethereumService.switchToPolygonNetwork();
    // };

    return {
      addressCardano,
      isLoading,
      loginOrSignUp,
      loginOrSignUpCardano,
      openRegistrationModal,
      // switchToPolygonNetwork,
      isBeginConnectionModalOpen,
    };
  },
};
</script>

<style lang="scss" scoped src="@/Common/Styles/AppMenuBarStyles.scss"></style>
<style
  lang="scss"
  scoped
  src="@/Common/Styles/UserBalanceAndAddress.scss"
></style>
<style
  lang="scss"
  scoped
  src="@/Common/Styles/UserBalanceAndAddressCardano.scss"
></style>
